import React from 'react'
import { Card, Row, Container, CardHeader, Col, CardBody, CardTitle, NavItem, TabContent, NavLink, Nav, CardText, Button,    Table,
  FormGroup,
  FormText,
  Form,
  Input,
  Label,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,TabPane, ListGroup, ListGroupItem } from 'reactstrap'
  import { Link, useNavigate } from "react-router-dom";

const Videotest = () => {
  return (
    <div>
          <div style={{ overflowX: 'auto' }}>
                      <Table  hover>
                        <thead>
                          <tr style={{ background: "#F6F9FC" }}>
                            <th>S.NO</th>
                            <th>Given Test For</th>
                            <th>Test Video</th>
                            <th>Test Status</th>
                            {/* <th>Action</th> */}
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>1</td>
                            <td><i class="fa-solid fa-file"></i></td>
                            <td>@mdo</td>
                            <td>Qualified</td>
                      
                          </tr>
                          <tr>
                            <td>2</td>
                            <td><i class="fa-solid fa-file"></i></td>
                            <td>@mdo</td>
                            <td>Not-Qualified</td>
                         
                          </tr>
                    

                        </tbody>
                      </Table>
                    </div>
                    <br />
                  
    </div>
  )
}

export default Videotest
